import { MapContext } from 'components/Mapbox/Mapbox'
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { HelpToggle } from '../HelpToggle'

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

const InteractiveToggleDefaults: {
  labelOn: string
  labelOff: string
} = {
  labelOn: 'Verschieben aktivieren',
  labelOff: 'Karte deaktivieren',
}

export const InteractiveToggle = ({
  viewToReturnToOnDeactivation,
  returnToViewAtActivation = false,
  isOutside = false,
  onDeactivate,
}: {
  viewToReturnToOnDeactivation?: mapboxgl.CameraOptions | undefined
  returnToViewAtActivation?: boolean
  isOutside?: boolean
  onDeactivate?: () => void
}) => {
  var {
    map,
    isInteractive,
    setViewToReturnTo,
    setIsInteractive,
    viewToReturnTo,
    isMobile,
    scrollTarget,
  } = useContext(MapContext)

  useEffect(() => {
    if (!map) return

    if (isMobile) {
      if (!isInteractive) {
        map.scrollZoom.disable()
        map.dragPan.disable()
      } else {
        map.scrollZoom.enable()
        map.dragPan.enable()
        map.touchZoomRotate.enableRotation()
      }
    } else {
      if (!isInteractive) {
        map.scrollZoom.disable()
        map.dragPan.disable()
      } else {
        map.scrollZoom.enable()
        map.dragPan.enable()
      }
    }
    if (!isInteractive) {
      if (viewToReturnToOnDeactivation) {
        map.flyTo(viewToReturnToOnDeactivation)
      } else if (returnToViewAtActivation && viewToReturnTo) {
        map.flyTo(viewToReturnTo)
      }
    }

    //   map.dragPan.disable()
    //   map.scrollZoom.disable()
    //   map.touchPitch.disable()
    //   map.dragRotate.disable()
    //   map.doubleClickZoom.disable()
    //   map.keyboard.disable()
    //   map.boxZoom.disable()
    //   map.touchZoomRotate.disableRotation()
    // } else {
    //   if (returnToViewAtActivation && setViewToReturnTo) {
    //     setViewToReturnTo({
    //       center: map.getCenter(),
    //       zoom: map.getZoom(),
    //       bearing: map.getBearing(),
    //       pitch: map.getPitch(),
    //     })
    //   }
    //   if (isMobile) {
    //     // map.getContainer().scrollIntoView({ behavior: 'smooth' })
    //   }
    //   map.dragPan.enable()
    //   map.scrollZoom.enable()
    //   map.touchPitch.enable()
    //   map.dragRotate.enable()
    //   map.doubleClickZoom.enable()
    //   map.keyboard.enable()
    //   map.boxZoom.enable()
    //   map.touchZoomRotate.enableRotation()
    // }
  }, [isInteractive, map])

  return (
    <InteractiveToggleArea isOutside={isOutside}>
      <InteractiveToggleRoot
        isOutside={isOutside}
        isInteractive={!!isInteractive}
        onClick={() => {
          if (!isInteractive) {
            if (scrollTarget) {
              scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              })
            }
          }
          if (isInteractive && onDeactivate) {
            onDeactivate()
          }
          setIsInteractive && setIsInteractive(!isInteractive)
        }}
        style={{
          left: isMobile ? 'calc(50% - 20px)' : '50%',
        }}
      >
        {isInteractive
          ? InteractiveToggleDefaults.labelOff
          : InteractiveToggleDefaults.labelOn}
      </InteractiveToggleRoot>
      {isInteractive && <HelpToggle />}
    </InteractiveToggleArea>
  )
}

const InteractiveToggleArea = styled.div<{
  isOutside: boolean
}>`
  z-index: 4;
  position: ${(props) => (props.isOutside ? '' : 'absolute')};
  bottom: 35px;
  width: 100%;
  display: flex;
  justify-content: center;
`

const InteractiveToggleRoot = styled.button<{
  isInteractive: boolean
  isOutside: boolean
}>`
  margin-right: 5px;
  border: 0;
  font-size: 15px;

  color: ${(props) =>
    props.isInteractive ? '#fff' : 'var(--site-background)'};

  background-color: ${(props) =>
    props.isInteractive ? 'var(--red-main)' : 'var(--text-color)'};
  width: 220px;
  padding: 18px 20px 15px 20px;
  border-radius: 2px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  @media screen and (max-width: 711px) {
    font-size: 13px;
    padding: 10px 10px 10px 10px;
    width: 200px;
  }
  @media screen and (min-width: 712px) {
    &:hover {
      cursor: pointer;
      background-color: ${(props) =>
        props.isInteractive ? 'var(--red-bright-1)' : 'var(--brandblue-main)'};
      color: #fff;
    }
  }
`
